import { useCallback } from 'react';

import { TooltipData } from './CursorTooltip.types';

interface ShowTooltipConfig {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  setTooltipData: React.Dispatch<React.SetStateAction<TooltipData>>;
  onVisibilityChange?: (isVisible: boolean) => void;
  onActiveTooltipChange?: (tooltipId: string | null) => void;
}

export const useShowTooltip = (config: ShowTooltipConfig) => {
  const {
    isVisible,
    setIsVisible,
    setTooltipData,
    onVisibilityChange,
    onActiveTooltipChange,
  } = config;

  return useCallback(
    (message: TooltipData, tooltipId: string | null) => {
      setTooltipData((prev) => {
        if (prev.title === message.title && prev.content === message.content) {
          return prev;
        }
        return message;
      });

      if (!isVisible) {
        requestAnimationFrame(() => {
          setIsVisible(true);
          onVisibilityChange?.(true);
          onActiveTooltipChange?.(tooltipId);
        });
      } else {
        onActiveTooltipChange?.(tooltipId);
      }
    },
    [
      isVisible,
      setIsVisible,
      setTooltipData,
      onVisibilityChange,
      onActiveTooltipChange,
    ],
  );
};
